import { AiChatState } from "@intelligems/ig-types/schemas/ai/ai-chat-state";
import { aiApiClient } from "@src/api/ai-api";
import { aiExperienceCreationChatKeys } from "@src/api/queryKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";

interface UseGetExperienceCreationChatSessionHistoryOptions {
  sessionId: string | null | undefined;
  enabled?: boolean;
}

const getExperienceCreationChatSessionHistory = async (
  sessionId: string
): Promise<AiChatState | null> => {
  const response = await aiApiClient.get<AiChatState | null>(
    `/chat-history/session/${sessionId}`
  );
  return response.data ?? null;
};

// Shared query definition -- lets non-component code (e.g. the
// closeBuilder/seedCreationHandoffOnExit thunk, which can't call hooks) go
// through `queryClient.fetchQuery` with the exact same key + fetcher this
// hook uses, instead of exporting the raw fetcher for direct use.
export const experienceCreationChatSessionHistoryQueryOptions = (
  sessionId: string
) =>
  queryOptions<AiChatState | null>({
    queryKey: aiExperienceCreationChatKeys.chatSessionHistory(sessionId),
    queryFn: () => getExperienceCreationChatSessionHistory(sessionId),
  });

export const useGetExperienceCreationChatSessionHistory = ({
  sessionId,
  enabled = true,
}: UseGetExperienceCreationChatSessionHistoryOptions) => {
  return useQuery({
    ...experienceCreationChatSessionHistoryQueryOptions(sessionId ?? ""),
    enabled: enabled && !!sessionId,
  });
};
